(() => {
  const init = (carousel) => {
    if (carousel.dataset.bsibReady === 'true') return;
    carousel.dataset.bsibReady = 'true';

    const tabs = Array.from(carousel.querySelectorAll('[data-bsib-tab]'));
    const slides = Array.from(carousel.querySelectorAll('.bsib__slide'));
    let active = Math.max(0, tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));

    const show = (index, shouldPlay = true) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const selected = i === active;
        slide.hidden = !selected;
        slide.classList.toggle('is-active', selected);
        const video = slide.querySelector('video');
        if (!video) return;
        if (!selected) video.pause();
        else if (shouldPlay) video.play().catch(() => {});
      });
      tabs.forEach((tab, i) => {
        const selected = i === active;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });
    };

    carousel.addEventListener('bison:video-reveal', event => {
      const index = slides.indexOf(event.detail.slide);
      if (index >= 0) show(index, false);
    });
    tabs.forEach((tab, index) => tab.addEventListener('click', () => show(index, true)));
    carousel.querySelector('[data-bsib-prev]')?.addEventListener('click', () => show(active - 1, true));
    carousel.querySelector('[data-bsib-next]')?.addEventListener('click', () => show(active + 1, true));

    carousel.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (!event.target.matches('[data-bsib-tab]')) return;
      event.preventDefault();
      const next = active + (event.key === 'ArrowRight' ? 1 : -1);
      show(next, true);
      tabs[active]?.focus();
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) entry.target.pause();
      });
    }, { threshold: 0.15 });
    slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (video) observer.observe(video);
    });

    show(active, false);
  };

  document.querySelectorAll('[data-bsib-carousel]').forEach(init);
})();

